import type { ReactNode } from 'react'
import React, { useContext } from 'react'
import { IconArrowLeft } from '@s4l/icons/IconArrowLeft'
import { IconArrowRight } from '@s4l/icons/IconArrowRight'
import { BreakpointSizes, useBrowser } from '@s4l/utils/hooks/useBrowser'
import type { UtilityClassNames } from '@s4l/utility-css'
import { CardContext } from '..'
import Carousel from '../../../Molecules/Carousel'
import Button from '../../../Atoms/Button'
import Placeholder from '../../../Atoms/Placeholder'

import styles from './index.module.css'

interface IActionProps {
  children: ReactNode
}

export const Images = (props: IActionProps) => {
  const { children } = props

  const { url, Link, variant, onClick } = useContext(CardContext)

  const { activeBreakpoint } = useBrowser()

  const nextChildren = React.Children.map(children, child => (
    <Link
      href={url}
      target={activeBreakpoint >= BreakpointSizes.L ? '_blank' : '_self'}
      onClick={onClick}
    >
      {child}
    </Link>
  ))

  return (
    <div data-variant={variant} className={styles.images}>
      <Carousel preset="single-items">
        <Carousel.Content>{nextChildren}</Carousel.Content>
        <Carousel.Buttons>
          <Button
            className={styles.carouselPrevBtn as UtilityClassNames}
            variant="icon-rounded"
            size="extraSmall"
            leadingIcon={<IconArrowLeft />}
          />
          <Button
            className={styles.carouselNextBtn as UtilityClassNames}
            variant="icon-rounded"
            size="extraSmall"
            leadingIcon={<IconArrowRight />}
          />
        </Carousel.Buttons>
        <Carousel.Dots />
      </Carousel>
    </div>
  )
}

function PlaceholderImages() {
  return (
    <div className={styles.images}>
      <Placeholder height="inherit" />
    </div>
  )
}

PlaceholderImages.displayName = 'Card.Images.Placeholder'

Images.Placeholder = PlaceholderImages

Images.displayName = 'Card.Images'
